import styled from 'styled-components';

import { media } from 'utils/detection';

export default styled.div`
  position: relative;
  text-align: right;
  width: 100%;
  margin: 80px 0px 0px -20px;

  ${media.medium`
    position: fixed;
    display: flex;
    flex-direction: column;
    margin: 0;
    width: 100px;
    margin: 0;
    top: 50%;
    left: 5%;
    transform: translate(0, -50%);
  `}
`;
